import React, { useState, useContext } from 'react'
import ApplicationContext from '../../context/ApplicationContext'
import PropTypes from 'prop-types'
import Badge from '../Badge/Badge'
import styles from './LocationBadges.module.scss'
import { ReactComponent as PldFitterIcon } from '../../assets/media/icons/pld-fitter-badge.svg'
import { ReactComponent as MrPing } from '../../assets/media/icons/icon-mr-ping.svg'
import { ReactComponent as RibbonIcon } from '../../assets/media/icons/ribbon.svg'
import { ReactComponent as FittorOfTheYearIcon } from '../../assets/media/icons/icon-star-white.svg'

const LocationBadges = props => {
    const [applicationData] = useContext(ApplicationContext)
    const [localizations] = useState(applicationData.localizations)

    return (
        <div className={styles.container}>
            {props?.fitterOfTheYear && <Badge color='green' Icon={<FittorOfTheYearIcon />} text={localizations.powerFitterOfTheYear} />}
            {props?.certifiedFitter && <Badge color='blue' Icon={<RibbonIcon />} text={localizations.certifiedFitter} />}
            {props?.fittingExperience && <Badge color='purple' Icon={<MrPing />} text={localizations.pingFittingExperience} />}
            {props?.pldFitter && <Badge color='orange' Icon={<PldFitterIcon />} text={localizations.pldMilled} />}
        </div>
    )
}

LocationBadges.propTypes = {
    certifiedFitter: PropTypes.bool,
    pldFitter: PropTypes.bool,
    fitterOfTheYear: PropTypes.bool,
    fittingExperience: PropTypes.bool,
}

export default LocationBadges
